import {faker} from '@faker-js/faker';
import PollIcon from '@mui/icons-material/Poll';
import QuizIcon from '@mui/icons-material/Quiz';
import GradeIcon from '@mui/icons-material/Grade';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import ExtensionIcon from '@mui/icons-material/Extension';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import MarginIcon from '@mui/icons-material/Margin';
import PaddingIcon from '@mui/icons-material/Padding';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import PsychologyIcon from '@mui/icons-material/Psychology';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import Filter5Icon from '@mui/icons-material/Filter5';
import jigsaw_puzzle_unsolved from '../static/images/questionImages/jigsaw_puzzle_unsolved.gif';
import puzzle_solved from '../static/images/questionImages/jigsaw_puzzle_solved.png';
import crossWord_unsolved from '../static/images/questionImages/crossWord_unsolved.gif';
import crossWord_solved from '../static/images/questionImages/crossword_solved.png';
import image_swap_unsolved from '../static/images/questionImages/image_swap.gif';
import image_swap_solved from '../static/images/questionImages/image_swap_solved.png';
import spin_wheel from '../static/images/questionImages/spin_wheel.gif';
import spin_wheel_solved from '../static/images/questionImages/spin_wheel_solved.png';
import wordle_unsolved from '../static/images/questionImages/wordle_unsolved.gif';
import wordle_solved from '../static/images/questionImages/wordle_solved.png';
import crossmath_unsolved from '../static/images/questionImages/crossmath_unsolved.gif';
import crossmath_solved from '../static/images/questionImages/crossmath_solved.png';
import image_word_puzzle_unsolved from '../static/images/questionImages/image_word_puzzle_unsolved.gif';
import image_word_solved from '../static/images/questionImages/image_word_solved.png';


import ShutterSpeedTwoToneIcon from '@mui/icons-material/ShutterSpeedTwoTone';

// Implement puzzles like this https://puzzlemaker.discoveryeducation.com/criss-cross
// https://puzzel.org/
// https://www.jigsawplanet.com/
// https://www.247games.com/
// https://flutter.dev/events/puzzle-hack
// https://www.jigsawexplorer.com/
// https://poki.com/en/g/photo-puzzle-swap-edition
export const QUESTION_TYPES = {
  POLL: 'Poll',
  QUIZ: 'Quiz',
  RANK: 'Rank',
  FACT: 'Fact',
  RATING: 'Rating',
  DOUBLE_PUZZLE: 'Scramble words / Double puzzle', // https://puzzlemaker.discoveryeducation.com/double-puzzle
  FLASH_CARD: 'Flash Card', // http://localhost:3000/question-example/flashcard
  IMAGE_SWAP: 'Image SWAP',
  JIGSAW_PUZZLE: 'Jigsaw', // https://www.geeksforgeeks.org/puzzle-using-react-jigsaw-puzzle-package/ ,
  // http://localhost:3000/question-example/jigsaw-puzzle
  WORD_SEARCH_PUZZLE: 'Word Search Puzzle', // https://codepen.io/imdigvijay/full/gqzJKX
  CROSS_WORD_PUZZLE: 'Cross Word Puzzle', // http://localhost:3000/question-example/crossword
  CONNECTIONS: 'Connections',
  MARKS: 'Score',
  WORDLE: 'Wordle',
  GUESS_BLURRED_IMAGE: 'Guess Blurred Image',
  SPIN_THE_WHEEL: 'Spin The Wheel',
  JUMBLED_SENTENCE: 'Jumbled sentence',
  MEMORY_GAME: 'Memory GAME',
  IMAGE_WORD_PUZZLE: 'Image word puzzle',
  SPIN_A_WHEEL: 'Spin a wheel',
  BASIC_MATH: 'Basic Math',
  MATH_SQUARE: 'Math Square'
}

export const SUBTYPE_NOT_APPLICABLE = 'NA'

const iconStyles = {fontSize: 'large'}
export const QUESTION_TYPES_BY_CATEGORY = {
  BASIC: {
    [QUESTION_TYPES.POLL]: {
      icon: <PollIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.POLL,
      label: QUESTION_TYPES.POLL
    },
    [QUESTION_TYPES.QUIZ]: {
      icon: <QuizIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.QUIZ,
      label: QUESTION_TYPES.QUIZ
    },
    [QUESTION_TYPES.RANK]: {
      icon: <FormatListNumberedIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.RANK,
      label: QUESTION_TYPES.RANK
    },
    [QUESTION_TYPES.SPIN_A_WHEEL]: {
      icon: <ShutterSpeedTwoToneIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.SPIN_A_WHEEL,
      label: QUESTION_TYPES.SPIN_A_WHEEL
    },
  },
  SCORE: {
    [QUESTION_TYPES.RATING]: {
      icon: <GradeIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.RATING,
      label: QUESTION_TYPES.RATING,
    },
    [QUESTION_TYPES.MARKS]: {
      icon: <LocalConvenienceStoreIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.MARKS,
      label: QUESTION_TYPES.MARKS,
    }
  },
  IMAGE_PUZZLES: {
    [QUESTION_TYPES.JIGSAW_PUZZLE]: {
      icon: <ExtensionIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.JIGSAW_PUZZLE,
      label: QUESTION_TYPES.JIGSAW_PUZZLE
    },
    [QUESTION_TYPES.IMAGE_SWAP]: {
      icon: <SwapHorizontalCircleIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.IMAGE_SWAP,
      label: QUESTION_TYPES.IMAGE_SWAP
    },
    [QUESTION_TYPES.CONNECTIONS]: {
      icon: <SettingsInputComponentIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.CONNECTIONS,
      label: QUESTION_TYPES.CONNECTIONS
    },
    [QUESTION_TYPES.GUESS_BLURRED_IMAGE]: {
      icon: <BrokenImageIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.GUESS_BLURRED_IMAGE,
      label: QUESTION_TYPES.GUESS_BLURRED_IMAGE
    },
    [QUESTION_TYPES.IMAGE_WORD_PUZZLE]: {
      icon: <BrokenImageIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.IMAGE_WORD_PUZZLE,
      label: QUESTION_TYPES.IMAGE_WORD_PUZZLE
    }

  },
  WORD_PUZZLE: {
    [QUESTION_TYPES.WORD_SEARCH_PUZZLE]: {
      icon: <ScreenSearchDesktopIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.WORD_SEARCH_PUZZLE,
      label: QUESTION_TYPES.WORD_SEARCH_PUZZLE
    },
    [QUESTION_TYPES.CROSS_WORD_PUZZLE]: {
      icon: <MarginIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.CROSS_WORD_PUZZLE,
      label: QUESTION_TYPES.CROSS_WORD_PUZZLE
    },
    [QUESTION_TYPES.DOUBLE_PUZZLE]: {
      icon: <PaddingIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.DOUBLE_PUZZLE,
      label: QUESTION_TYPES.DOUBLE_PUZZLE
    },
    [QUESTION_TYPES.JUMBLED_SENTENCE]: {
      icon: <MoveUpIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.JUMBLED_SENTENCE,
      label: QUESTION_TYPES.JUMBLED_SENTENCE
    },
    [QUESTION_TYPES.MEMORY_GAME]: {
      icon: <PsychologyIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.MEMORY_GAME,
      label: QUESTION_TYPES.MEMORY_GAME
    },
    [QUESTION_TYPES.WORDLE]: {
      icon: <Filter5Icon {...iconStyles}/>,
      questionType: QUESTION_TYPES.WORDLE,
      label: QUESTION_TYPES.WORDLE
    }
  },
  MATH_PUZZLE: {
    [QUESTION_TYPES.BASIC_MATH]: {
      icon: <Filter5Icon {...iconStyles}/>,
      questionType: QUESTION_TYPES.BASIC_MATH,
      label: QUESTION_TYPES.BASIC_MATH
    },
    [QUESTION_TYPES.MATH_SQUARE]: {
      icon: <Filter5Icon {...iconStyles}/>,
      questionType: QUESTION_TYPES.MATH_SQUARE,
      label: QUESTION_TYPES.MATH_SQUARE
    }
  },
  CARDS: {
    [QUESTION_TYPES.FLASH_CARD]: {
      icon: <ViewCarouselIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.FLASH_CARD,
      label: QUESTION_TYPES.FLASH_CARD
    },
    [QUESTION_TYPES.FACT]: {
      icon: <PostAddIcon {...iconStyles}/>,
      questionType: QUESTION_TYPES.FACT,
      label: QUESTION_TYPES.FACT
    },


  }
}

export const RESULTS_VISIBILITY = {
  PUBLIC_AFTER_VOTE: 'Public after vote',
  NOT_PUBLIC: 'Not public',
  PUBLIC_AFTER_END_DATE: 'Public after end date'
}

export const POLL_AND_QUIZ_SUBTYPE = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  MULTI_CHOICE_TEXT: 'MULTI_CHOICE_TEXT',
  NONE: 'NONE',
  RATING: 'RATING',
}

export const USER_NAMES = {
  KUMAR: {
    name: faker.person.fullName()
  },
  ARJUN: {
    name: faker.person.fullName()
  },
  GANESH: {
    name: faker.person.fullName()
  },
  ADITYA: {
    name: faker.person.fullName()
  }
}

export const CATEGORIES = {
  SPORTS: 'Sports',
  MOVIES: 'Movies',
  ARTS: 'Arts',
  LIFESTYLE: 'Lifestyle',
  TECHNOLOGY: 'Technology',
}

export const CONTENT_LANGUAGES = {
  ENGLISH: 'English',
  TAMIL: 'தமிழ்',
  HINDI: 'हिंदी',
  BENGALI: 'বাংলা',
  Bengali: 'ലമയ്ലം',
}

export const PUZZLE_DIFFICULTY_LEVEL = {
  EASY: 'Easy',
  MEDIUM: 'Medium',
  HARD: 'Hard'
}
export const NUMBER_OF_ATTEMPTS = {
  UNLIMITED: 'Unlimited',
  ONE: '1',
  TWO: '2',
  THREE: '3',
}

export const SORT_BY = {
  RECENT: 'Recent',
  POPULAR: 'Popular',
  TOP: 'Top'
}

export const LIVE_EXPIRE_FILTERS = {
  LIVE: 'Live',
  EXPIRED: 'Expired'
}

export const READ_MORE_CUT_OFF_LENGTH = 50

export const URLS = {
  INDEX: '/',
  HOME: '/home',
  SIGN_IN: '/signin',
  POLLS: '/polls',
  QUESTION_CREATE: '/polls/create',
  QUESTION_SINGLE: '/polls/:pollId',
  OTHER_APPS: '/other-apps',
  USER: '/user',
  HASHTAG: '/hashtag/:hashtagId',
  SETTINGS: '/profile',
  ACTIVITIES: '/activities',
  PROFILE_EDIT: '/profile/edit',
  PROFILE_NOTIFICATION_SETTINGS: '/profile/notification-settings',
  LANGUAGE_SELECTION: '/language-selection',
  CONTENT_LANGUAGE_SELECTION: '/content-language-selection',
  CATEGORY: '/category',
  CATEGORY_ONE: '/category/:categoryId',
  PROFILE: '/user/:userId',
  IMAGE_FULL_SCREEN: '/image/:url',
  FILTERS: '/filters/:id',
  SEARCH: '/search/:searchTerm',
  PRIVACY_POLICY: '/privacy-policy',
  CHILD_POLICY: '/child-policy',
  DELETE_ACCOUNT: '/delete-account',
  LEADERBOARD: '/leaderboard',
  LOGO: '/logo',
  FIREBASE: '/firebase',
  BUY_COINS: '/buy-coins',
  MONETIZATION: '/monetization',
  COINS_DASHBOARD: '/coins-dashboard',
  SUPABASE: '/supabase',
  CLOUD_FUNCTION_TEST: '/cf-test',
  SELECT_QUESTION_TYPE: '/select-question-type',
  QUESTION_EXAMPLES: '/question-example',
  QUESTION_EXAMPLE_FLASH_CARD: '/question-example/flashcard',
  QUESTION_EXAMPLE_IMAGE_SWAP: '/question-example/image-swap',
  QUESTION_EXAMPLE_JIGSAW_PUZZLE: '/question-example/jigsaw-puzzle',
  QUESTION_EXAMPLE_WORD_SEARCH: '/question-example/word-search',
  QUESTION_EXAMPLE_CROSSWORD: '/question-example/crossword',
  QUESTION_EXAMPLE_DOUBLE_PUZZLE: '/question-example/double-puzzle',
  JIGSAW_PUZZLE_TASK: '/question-example/jigsaw-puzzle-task',
}

export const CREATED_DATE_VALUES = faker.helpers.arrayElement(['5d', '1w', '3m', '1y'])

export const FILTERED_POLLS_TYPES = {
  CREATED_POLLS: 'My Questions',
  LIKED_POLLS: 'Liked Questions',
  SAVED_POLLS: 'Saved Questions',
  SKIPPED_POLLS: 'Skipped Questions',
  ANSWERED_POLLS: 'Answered Questions'
}

export const SOLVING_METHODS = {
  COINS: 'COINS',
  ADS: 'ADS',
  MANUALLY: 'MANUALLY',
}
export const QUESTION_TYPE_OPTIONS_MAP = {
  [QUESTION_TYPES.JIGSAW_PUZZLE]: ['Solved', 'Unsolved'],
  [QUESTION_TYPES.CROSS_WORD_PUZZLE]: ['Solved', 'Unsolved'],
  [QUESTION_TYPES.IMAGE_SWAP]: ['Solved', 'Unsolved'],
  [QUESTION_TYPES.SPIN_A_WHEEL]: ['1', '2', '3', '4', '5'],
  [QUESTION_TYPES.WORDLE]: ['Solved', 'Unsolved'],
  [QUESTION_TYPES.BASIC_MATH]: ['Solved', 'Unsolved'],
  [QUESTION_TYPES.MATH_SQUARE]: ['Solved', 'Unsolved'],
  [QUESTION_TYPES.IMAGE_WORD_PUZZLE]: ['Solved', 'Unsolved']
}

export const QUESTION_TYPE_IMAGE_MAP = {
  [QUESTION_TYPES.JIGSAW_PUZZLE]: {
    UNSOLVED: jigsaw_puzzle_unsolved,
    SOLVED: puzzle_solved,
  },
  [QUESTION_TYPES.CROSS_WORD_PUZZLE]: {
    UNSOLVED: crossWord_unsolved,
    SOLVED: crossWord_solved,
  },
  [QUESTION_TYPES.IMAGE_WORD_PUZZLE]: {
    UNSOLVED: image_word_puzzle_unsolved,
    SOLVED: image_word_puzzle_unsolved,
  },
  [QUESTION_TYPES.IMAGE_SWAP]: {
    UNSOLVED: image_swap_unsolved,
    SOLVED: image_swap_solved,
  },
  [QUESTION_TYPES.SPIN_A_WHEEL]: {
    UNSOLVED: spin_wheel,
    SOLVED: spin_wheel_solved,
  },
  [QUESTION_TYPES.WORDLE]: {
    UNSOLVED: wordle_unsolved,
    SOLVED: wordle_solved,
  },
  [QUESTION_TYPES.MATH_SQUARE]: {
    UNSOLVED: crossmath_unsolved,
    SOLVED: crossmath_solved,
  }
}

export const QUESTION_STATE_SCENARIOS = {
  SOLVED_COMPLETELY: 'SOLVED_COMPLETELY',
  PARTIALLY_SOLVED: 'PARTIALLY_SOLVED',
  NOT_STARTED: 'NOT_STARTED'
}